export enum AccountStatus {
  Pending = 'PENDING',
  Created = 'CREATED',
  Disabled = 'DISABLED',
  PartiallyCreated = 'PARTIALLY_CREATED',
}

export type SellingAccountType =
  | 'AMAZON_SELLER'
  | 'AMAZON_VENDOR'
  | 'AMAZON_AUTHOR';

// GRS Model: https://tiny.amazon.com/1pv8325b/codeamazpackGlobblob6c1bmode
export type Portal =
  | 'AUTHOR_CENTRAL'
  | 'KDP_CENTRAL'
  | 'SELLER_CENTRAL'
  | 'GROCERY_CENTRAL'
  | 'VENDOR_CENTRAL'
  | 'MERCH';

export enum BillToType {
  ManagerAccount = 'MANAGER_ACCOUNT',
  AdvertiserAccount = 'ADVERTISER_ACCOUNT',
}

export enum AdProductGroup {
  SPONSORED_ADS = 'SPONSORED_ADS',
  ADSP = 'ADSP',
  unknown_default_open_api = 'unknown_default_open_api',
}

export enum EntityType {
  Adsp = 'DSP_ADVERTISING_ACCOUNT', // An SGA is defined as an entity where the entity type is DSP_ADVERTISING_ACCOUNT, and it has an associated GA ID
  Brand = 'BRAND',
  // TODO: add all other types
}

export interface Business {
  zipCode: string;
  phone: string;
  website: string;
  city: string;
  countryCode: string;
  businessName: string;
  addressLine1: string;
  addressLine2?: string;
  state: string;
  selectedAddressId?: string;
  businessRegistrationNumber?: string;
}

export interface SellingAccount {
  sellingAccountLinkToken: string;
  displayName: string;
  sellingProgram: SellingAccountType;
  countryCodes: string[];
  portals: Portal[];
  business?: BusinessInfo;
}

export interface LinkedSellingAccount {
  sellingAccountLinkToken: string;
  displayName: string;
  sellingProgram: SellingAccountType;
  countryCodes: string[];
  portals: Portal[];
  url: string;
}

export interface SellingAccountsResponse {
  nextToken?: string;
  sellingAccounts: SellingAccount[];
}

export interface Account {
  displayName: string;
  regionalEntityId: string;
  entityType: string;
  status: AccountStatus;
  sellingAccounts: LinkedSellingAccount[];
  business: Business;
  businessVerificationStatus?: BusinessVerificationStatus;
  retailerId?: string;
  sellingAccountId?: string;
  currency?: string;
  timeZone?: string;
  industry?: string;
  saEntityId?: string;
  saEntityMarketplaceId?: string;
  saEntityUrl?: string;
}

export interface BusinessAddress {
  addressToken: string;
  state: string;
  city: string;
  zipCode: string;
  countryCode: string;
  addressLine1: string;
  businessName: string;
  addressLine2?: string;
  phoneNumber?: string;
}

// New business type to be used for registration.
export interface BusinessInfo {
  website: string;
  addresses: BusinessAddress[];
}

export interface Enumerations {
  industries: Array<{ value: string; label: string }>;
  currencies: Array<{ value: string; label: string }>;
  timeZones: Array<{ value: string; label: string }>;
}

export enum BusinessVerificationStatus {
  Verified = 'VERIFIED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}
